// https://docs.heap.io/reference

export function sendTrackEvent(
  name: string,
  properties?: { [key: string]: string | number | boolean },
) {
  const heap = window.heap;
  if (heap) {
    heap.track(name, properties);
  }
}

export function addEventProperties(properties: { [key: string]: string | number | boolean }) {
  const heap = window.heap;
  if (heap) {
    heap.addEventProperties(properties);
  }
}

export default {
  sendTrackEvent,
  addEventProperties,
};
